import Vue from "vue";
import Vuex from "@store/store";
import { baseUrl, isSignedIn, getHeaders } from "@services/AuthServices";
import { queryFilter } from "@src/filters/query-filter";

Vue.use(Vuex);

export async function TechInfoServicesGetWiringManualList(searchText) {
    await isSignedIn();

    let query = "";
    if (searchText) {
        query = queryFilter({ searchText });
    }
    const urlApi = `${baseUrl}/TechnicalInformation/Wiring/GetWiringManualList${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetWiringManualHtml(id) {
    await isSignedIn();

    const query = queryFilter({ manualId: id });
    const urlApi = `${baseUrl}/TechnicalInformation/Wiring/GetWiringManualHtml${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetConfortWiringManualList(searchParam) {
    await isSignedIn();

    let query = "";
    if (searchParam) {
        query = queryFilter({ searchText: searchParam });
    }
    const urlApi = `${baseUrl}/TechnicalInformation/ConfortWiring/GetConfortWiringManualList${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetConfortWiringManualHtml(id) {
    await isSignedIn();

    const query = queryFilter({ manualId: id });
    const urlApi = `${baseUrl}/TechnicalInformation/ConfortWiring/GetConfortWiringManualHtml${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetBulletinsList(searchParam) {
    await isSignedIn();

    let query = "";
    if (searchParam) {
        query = queryFilter({ searchText: searchParam });
    }
    const urlApi = `${baseUrl}/TechnicalInformation/Bulletins/GetBulletinsList${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetManualsFromManualID(id) {
    await isSignedIn();

    const query = queryFilter({ manualId: id });
    const urlApi = `${baseUrl}/TechnicalInformation/Manuals/GetManualsFromManualId${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetManualsErrorCode(errorCode) {
    await isSignedIn();

    const query = queryFilter({ searchText: errorCode });
    const urlApi = `${baseUrl}/TechnicalInformation/Manuals/GetAllErrorCodeSearched${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetDiagnosticList(
    searchText,
    componentTypeId = null
) {
    await isSignedIn();

    let query = "";
    if (searchText || componentTypeId) {
        query = queryFilter({ searchText, componentTypeId });
    }
    const urlApi = `${baseUrl}/TechnicalInformation/Diagnostics/GetDiagnosticList${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetDiagnosticManual(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/TechnicalInformation/Diagnostics/GetDiagnosticManual`;

    return axios.post(urlApi, body, getHeaders(true));
}

export async function TechInfoServicesResolveServiceProposal(payload) {
    await isSignedIn();

    const query = queryFilter(payload);
    const urlApi = `${baseUrl}/TechnicalInformation/maintenance/service-proposal${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetMaintenancePlanHtml(id, body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/TechnicalInformation/GetMaintenancePlanHtml`;

    if (id) {
        let dateFormated = "";
        let kms = "";
        let step1 = Vuex.getters["techInfo/getTechInfoStep1"];
        if (Object.keys(step1).length === 0 && step1.constructor === Object) {
            Vuex.getters["vehicleIdentification/getState"].data.forEach(
                (item, index) => {
                    if (item.description === "Plate_Date") {
                        let arrayDate = item.value.split("");
                        dateFormated = `${arrayDate[0]}${arrayDate[1]}${arrayDate[2]}${arrayDate[3]}-${arrayDate[4]}${arrayDate[5]}-${arrayDate[6]}${arrayDate[7]}`;
                    }
                }
            );
        } else {
            dateFormated =
                Vuex.getters["techInfo/getTechInfoStep1"].fields.date.value;
            kms = Vuex.getters["techInfo/getTechInfoStep1"].fields.Kilometers;
        }

        id = id ? (id.length > 0 ? id : [id]) : 0;

        body = {
            serviceworkIds: id,
            additionalWorkIds: id,
            date: dateFormated,
            kilometers: kms,
            printView: false,
        };
    }

    return axios.post(urlApi, body, getHeaders(true));
}

export async function TechInfoServicesGetMaintenanceVariables(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/TechnicalInformation/GetMaintenanceVariables`;

    return axios.post(urlApi, body, getHeaders(true));
}

export async function TechInfoServicesGetGearBox() {
    await isSignedIn();

    const urlApi = `${baseUrl}/TechnicalInformation/GetPossibleGearBox`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetAdjustMainGroup(id) {
    await isSignedIn();

    const query = queryFilter({ mainGroupId: id });
    const urlApi = `${baseUrl}/TechnicalInformation/Adjust/GetAdjustMainGroup${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetAdjustSubGroup(id) {
    await isSignedIn();

    const query = queryFilter({ subGroupId: id });
    const urlApi = `${baseUrl}/TechnicalInformation/Adjust/GetAdjustSubGroup${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetLinkedTechnicalManuals(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/TechnicalInformation/Manuals/GetLinkedTechnicalManuals`;

    return axios.post(urlApi, body, getHeaders(true));
}

export async function TechInfoServicesGetAdjustHtmlFromItemMpId(id) {
    await isSignedIn();

    const query = queryFilter({ itemMpId: id });
    const urlApi = `${baseUrl}/TechnicalInformation/Adjust/GetAdjustHtmlFromItemMpId${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetRelaysFusesBoxOverviewImage() {
    await isSignedIn();

    const urlApi = `${baseUrl}/TechnicalInformation/RelaysFuses/GetRelaysFusesBoxOverviewImage`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetRelaysFusesBoxDetailList(id) {
    await isSignedIn();

    const query = queryFilter({ itemMpId: id });
    const urlApi = `${baseUrl}/TechnicalInformation/RelaysFuses/GetRelaysFusesBoxDetailList${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetRelaysFusesBoxDetail(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/TechnicalInformation/RelaysFuses/GetRelaysFusesBoxDetail`;

    return axios.post(urlApi, body, getHeaders(true));
}

export async function TechInfoServicesGetTyresVehicle() {
    await isSignedIn();

    const urlApi = `${baseUrl}/TechnicalInformation/tyres/vehicle`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetTimesWorkSteps(id) {
    await isSignedIn();

    const query = queryFilter({ subGroupId: id });
    const urlApi = `${baseUrl}/TechnicalInformation/Times/GetTimesWorkSteps${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetTimesList(searchParam) {
    await isSignedIn();

    let query = "";
    if (searchParam) {
        query = queryFilter({ searchText: searchParam });
    }
    const urlApi = `${baseUrl}/TechnicalInformation/Times/GetTimesList${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetAdjustList(searchParam) {
    await isSignedIn();

    let query = "";
    if (searchParam) {
        query = queryFilter({ searchText: searchParam });
    }
    const urlApi = `${baseUrl}/TechnicalInformation/Adjust/GetAdjustList${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetManualsList(searchParam) {
    await isSignedIn();

    let query = "";
    if (searchParam) {
        query = queryFilter({ searchText: searchParam });
    }
    const urlApi = `${baseUrl}/TechnicalInformation/Manuals/GetManualsList${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetAllSearchedTechnicalInformation(
    searchParams
) {
    await isSignedIn();

    const query = queryFilter({ searchText: searchParams });
    const urlApi = `${baseUrl}/TechnicalInformation/GetAllSearchedTechnicalInformation${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetAdjustSubGroupData(subGroupId) {
    await isSignedIn();

    const query = queryFilter({ subGroupId });
    const urlApi = `${baseUrl}/TechnicalInformation/Adjust/GetAdjustSubGroupData${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetAdjustSubGroupHtml(subGroupId) {
    await isSignedIn();

    const query = queryFilter({ subGroupId });
    const urlApi = `${baseUrl}/TechnicalInformation/Adjust/GetAdjustSubGroupHtml${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetComponentsLocationManual(
    locationManual
) {
    await isSignedIn();

    const query = queryFilter({ manualId: locationManual, printView: false });
    const urlApi = `${baseUrl}/TechnicalInformation/ComponentsLocation/GetComponentsLocationManual${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetComponentsLocationList() {
    await isSignedIn();

    const urlApi = `${baseUrl}/TechnicalInformation/ComponentsLocation/GetComponentsLocationList`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetLinkedConfortWiring(itemMpId) {
    await isSignedIn();

    const query = queryFilter({ itemMpId });
    const urlApi = `${baseUrl}/TechnicalInformation/ConfortWiring/GetLinkedConfortWiring${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetLinkedWiringDiagram(itemMpId) {
    await isSignedIn();

    const query = queryFilter({ itemMpId: itemMpId.replace(/\D/g, "") });
    const urlApi = `${baseUrl}/TechnicalInformation/Wiring/GetLinkedWiringDiagram${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetLinkedPartPosition(itemMpId) {
    await isSignedIn();

    const query = queryFilter({ itemMpId, linkType: 121 });
    const urlApi = `${baseUrl}/TechnicalInformation/Wiring/GetLinkedPartPosition${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetFuseRelaysComponentsForType() {
    await isSignedIn();

    const urlApi = `${baseUrl}/TechnicalInformation/Wiring/GetFuseRelaysComponentsForType`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetLinkedFuseRelays(
    itemMpId,
    componentTypeId
) {
    await isSignedIn();

    const query = queryFilter({ itemMpId, componentTypeId, linkType: 121 });
    const urlApi = `${baseUrl}/TechnicalInformation/Wiring/GetLinkedFuseRelays${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetDiagnosticsComponentsForType() {
    await isSignedIn();

    const urlApi = `${baseUrl}/TechnicalInformation/Wiring/GetDiagnosticsComponentsForType`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetDiagnosticsErrorCode(
    errorCode,
    componentTypeId
) {
    await isSignedIn();

    const query = queryFilter({ errorCode, componentTypeId });
    const urlApi = `${baseUrl}/TechnicalInformation/Diagnostics/GetErrorCode${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetLinkedDiagnostics(
    itemMpId,
    componentTypeId
) {
    await isSignedIn();

    const query = queryFilter({ itemMpId, componentTypeId });
    const urlApi = `${baseUrl}/TechnicalInformation/Wiring/GetLinkedDiagnostics${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetDiagnosticsLinkedWiringDiagrams(
    contentId
) {
    await isSignedIn();

    const query = queryFilter({ contentId });
    const urlApi = `${baseUrl}/TechnicalInformation/Diagnostics/GetLinkedWiringDiagrams${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetDiagnosticsLinkedWiringDiagramsFuses(
    itemMpId
) {
    await isSignedIn();

    const query = queryFilter({ itemMpId: itemMpId.replace(/\D/g, "") });
    const urlApi = `${baseUrl}/TechnicalInformation/RelaysFuses/LinkedWiringDiagrams${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetDiagnosticsLinkedRelaysAndFuses(
    contentId,
    componentID
) {
    await isSignedIn();

    const query = queryFilter({ contentId, componentID });
    const urlApi = `${baseUrl}/TechnicalInformation/Diagnostics/GetLinkedRelaysAndFuses${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetDiagnosticsLinkedPartPosition(
    contentId
) {
    await isSignedIn();

    const query = queryFilter({ contentId });
    const urlApi = `${baseUrl}/TechnicalInformation/Diagnostics/GetLinkedPartPosition${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetComponentsDiagnosticsLinkedPartPosition(
    imageLinkId,
    componentTypeId
) {
    await isSignedIn();

    const query = queryFilter({ imageLinkId, componentTypeId });
    const urlApi = `${baseUrl}/TechnicalInformation/Components/GetLinkedDiagnostics${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetComponentsWiringDiagnosticsDiagram(
    imageLinkId
) {
    await isSignedIn();

    const query = queryFilter({ imageLinkId });
    const urlApi = `${baseUrl}/TechnicalInformation/Components/GetLinkedWiringDiagram${query}`;

    return axios.get(urlApi, getHeaders(true));
}

export async function TechInfoServicesGetManufacturerManual() {
    await isSignedIn();

    const urlApi = `${baseUrl}/TechnicalInformation/manufacturer-manual-html`;

    return axios.get(urlApi, getHeaders(true));
}

export async function PrintTechnicalInformationManual(body) {
    await isSignedIn();

    const urlApi = `${baseUrl}/Generic/base64-to-pdf`;

    return axios.post(urlApi, body, {...getHeaders(true), responseType: 'blob'});
}

export async function TechInfoServicesGetCustomFluids() {
    await isSignedIn();

    const urlApi = `${baseUrl}/TechnicalInformation/fluids/custom`;

    return axios.get(urlApi, getHeaders(true));
}
